import React, { useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import IconButton from '@mui/material/IconButton';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import Tooltip from '@mui/material/Tooltip';
import { useBody } from '../../../../Body/state/BodyContext';

export default function BotonParaSeleccionarArchivo({ customValidator, archivosAceptados, setArchivos, }) {
    const { setMessage } = useBody();

    const {
        acceptedFiles,
        fileRejections,
        open,
        getInputProps
    } = useDropzone({
        accept: archivosAceptados,
        noClick: true, // evita que el click se asigne automáticamente
        noDrag: true,
        validator: customValidator
    });

    useEffect(() => {
        setArchivos(acceptedFiles);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acceptedFiles]);

    useEffect(() => {
        if (fileRejections.length > 0) {
            fileRejections.forEach((element, index) => {
                setMessage(fileRejections[index].errors[0].error);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fileRejections]);

    return (
        <div className="container" style={{ display: 'inline', marginRight: '20px' }}>
            <input {...getInputProps()} style={{ display: 'none' }} />
            <Tooltip title="Adjuntar archivos">
                <IconButton variant="contained" onClick={open} size="large" sx={{ color: 'primary.main' }}>
                    <AttachEmailIcon />
                </IconButton>
            </Tooltip>
        </div>
    );
}
